import { render } from "./CustomCategoryListView.vue?vue&type=template&id=0903cbaa&scoped=true&ts=true"
import script from "./CustomCategoryListView.vue?vue&type=script&lang=ts"
export * from "./CustomCategoryListView.vue?vue&type=script&lang=ts"

import "./CustomCategoryListView.vue?vue&type=style&index=0&id=0903cbaa&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0903cbaa"]])

export default __exports__